var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSearch = function SvgSearch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m18.9 20.3-5.6-5.6A6 6 0 0 1 9.5 16c-1.8 0-3.4-.6-4.6-1.9A6.3 6.3 0 0 1 3 9.5c0-1.8.6-3.4 1.9-4.6A6.3 6.3 0 0 1 9.5 3c1.8 0 3.4.6 4.6 1.9A6.3 6.3 0 0 1 16 9.5a6.1 6.1 0 0 1-1.3 3.8l5.6 5.6c.2.2.3.4.3.7s-.1.5-.3.7a1 1 0 0 1-.7.3 1 1 0 0 1-.7-.3M9.5 14c1.3 0 2.3-.4 3.2-1.3s1.3-2 1.3-3.2c0-1.3-.4-2.3-1.3-3.2S10.7 5 9.5 5c-1.3 0-2.3.4-3.2 1.3S5 8.3 5 9.5c0 1.3.4 2.3 1.3 3.2s2 1.3 3.2 1.3"
  })));
};
export default SvgSearch;